import React from "react";
import { styled } from '@mui/material/styles';
import Subcategory from "./Subcategory";

const PREFIX = 'Category';

const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
  sections: `${PREFIX}-sections`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    marginBottom: "1.5em",
    paddingTop: "1.5em",
    borderTop: "1px solid #999",
  },

  [`& .${classes.header}`]: {
    textTransform: "capitalize",
    marginBottom: "0.5em 0",
    display: "block",
  },

  [`& .${classes.sections}`]: {
    display: "inline-flex",
    flexWrap: "wrap",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flexDirection: "column",
    },
  }
}));

const Category = ({ category, subcategories }) => {


  return (
    <Root className={classes.root}>
		<div>
	      <span className={classes.header}>{category}</span>
	      <div className={classes.sections}>
	        {Object.keys(subcategories).map((key) => {
	          return (
	            <Subcategory subcategory={key} downloads={subcategories[key]} />
	          );
	        })}
	      </div>
		</div>
    </Root>
  );
};

export default Category;
